import z from "zod";

import { ErrorClassification } from "../../../sentry/classification";
import type { ErrorDetails } from "../domain";

const regionErrorTypeValues = ["UNKNOWN", "REGION_NAME_ALREADY_EXISTS"] as const;
const regionErrorTypeSchema = z.enum(regionErrorTypeValues);
const RegionErrorType = regionErrorTypeSchema.enum;
type RegionErrorType = z.infer<typeof regionErrorTypeSchema>;

export type RegionErrors =
  | { errorType: typeof RegionErrorType.UNKNOWN; data: undefined }
  | { errorType: typeof RegionErrorType.REGION_NAME_ALREADY_EXISTS; data: { name: string } };

export const regionErrorDetails: Record<RegionErrorType, ErrorDetails> = {
  UNKNOWN: { classification: ErrorClassification.UNEXPECTED_ERROR, sentryDescription: "Unknown Error" },
  REGION_NAME_ALREADY_EXISTS: {
    classification: ErrorClassification.CONFLICT_ERROR,
    sentryDescription: "Region name already exists",
  },
};
